import Button from '@mui/material/Button';
import React from "react";
import { useDispatch, connect } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from "@mui/material/Typography";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const mapStateToProps = state => {
    return {
        map: state.MapReducer
    }
};

const LayerDataSelection = (props) => {
    let [value, setValue] = React.useState(props.map.activeLayer);

    React.useEffect(() => {
        props.onLayerChange(`${value}`);
    }, [value]);

    const layerOptions = props.map.layerOptions || [];

    const folkSongsLayer = layerOptions.find(
        lo => lo.name === "Folk songs archive"
    );

    const folkDancesLayer = layerOptions.find(
        lo => lo.name === "Folk dances archive"
    );

    const normalLayers = layerOptions.filter(lo => {
        if (lo.layerId.includes("kulonb")) return false;
        if (lo.layerId.includes("grid")) return false;
        if (lo.name === "Folk songs archive") return false;
        if (lo.name === "Folk dances archive") return false;
        return true;
    });

    return (
        <div style={{ marginTop: 16 }}>
            <Typography variant="caption" gutterBottom component="div">
                Topic
            </Typography>

            <Select
                style={{ backgroundColor: '#ffffff' }}
                size='small'
                value={value}
                onChange={(e) => { setValue(e.target.value); }}
            >
                {normalLayers.map(lo => (
                    <MenuItem key={lo.layerId} value={lo.layerId}>
                        {lo.name}
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
};

export default connect(mapStateToProps)(LayerDataSelection);